import { DragInsertionLine } from "@ext/navigation/catalog/SidebarNavigation/components/SidebarDragnDrop/DragInsertionLine";
import { DropMode } from "@ext/navigation/catalog/SidebarNavigation/utils/dropMode";

interface ItemDragInsertionLineProps {
	dropMode: DropMode | false | undefined;
	/** Whether the row's first child claims the slot right below it with its own `before` target. */
	childOwnsSlotBelow?: boolean;
}

/**
 * The drag line a row draws for its own drop mode. Folders and articles render it through here so the two can
 * not drift apart: the same mode has to look the same wherever it lands.
 *
 * The one row that draws less is one whose first child claims the slot below it: an `into` line would land
 * exactly on that child's `before`. The row highlight says "into" there. A view's group has no such rival —
 * grouping offers no `before` at all — so an open group still draws the line.
 */
export const ItemDragInsertionLine = ({ dropMode, childOwnsSlotBelow }: ItemDragInsertionLineProps) => {
	if (!dropMode) return null;
	if (dropMode === DropMode.Into && childOwnsSlotBelow) return null;

	return (
		<DragInsertionLine
			className={dropMode === DropMode.Into ? "left-6" : undefined}
			position={dropMode === DropMode.Before ? "top" : undefined}
		/>
	);
};
